import React, { useMemo, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBadge from "components/MDBadge";
import MDSnackbar from "components/MDSnackbar";
import AppLoading from "verticales/AppLoading.tsx";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Card } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TableMaestros from "verticales/TableMaestros.tsx";
import fetchData from "verticales/FetchData";
import Switch from "@mui/material/Switch";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-aws";

function Dashboard() {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [cuentaSelect, setCuentaSelect] = useState({});
  const [rowToAction, setRowToAction] = useState(null);
  const [blocking, setBlocking] = useState(false);
  const [instanceState, setInstanceState] = useState("");
  const [openConfirmOff, setOpenConfirmOff] = useState(false);
  const [openConfirmOn, setOpenConfirmOn] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarContent, setSnackbarContent] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("info");

  useEffect(() => {
    const catData = async () => {
      try {
        setBlocking(true);
        const data = await fetchData(url, context, { action: "get" });
        setData(data.rows);
        setBlocking(false);
        // console.log("Data....", data);
      } catch (err) {
        console.log("Error al traer la data...", err);
      }
    };
    catData();
  }, []);

  const loadList = async (cuentaValue) => {
    try {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "get", cuenta: cuentaValue });
      setData(data.rows);
      setBlocking(false);
    } catch (err) {
      console.log("Error loading list data:", err);
    }
  };
  const handleOpenModal = (row) => {
    console.log("hola com oestsas!!!!!");
    setOpenModal(true);
    setRowSelect(row);
  };

  const handleOn = async () => {
    setOpenConfirmOn(false);
    setBlocking(true);
    const instanceId = rowToAction.original.instance_id;
    const cuenta = rowToAction.original.cuenta;
    const params = { action: "start", object: { instanceId, account: cuenta } };
    await fetchData(url, context, params);
    await loadList(cuentaSelect);
    setInstanceState("running");
    setBlocking(false);
    //setShowMessage(true);
    setSnackbarContent(
      `Instancia: ${instanceId} Estado: running. Dar un tiempo de espera de 1 minuto`
    );
    setSnackbarColor("success");
    setOpenSnackbar(true);
  };

  const handleOff = async () => {
    setOpenConfirmOff(false);
    setBlocking(true);
    const instanceId = rowToAction.original.instance_id;
    const cuenta = rowToAction.original.cuenta;
    const params = { action: "stop", object: { instanceId, account: cuenta } };
    await fetchData(url, context, params);
    await loadList(cuentaSelect);
    setInstanceState("stopped");
    setBlocking(false);
    //setShowMessage(true);
    setSnackbarContent(`
      Instancia: ${instanceId} Estado: stopped. Dar un tiempo de espera de 1 minuto`);
    setSnackbarColor("error");
    setOpenSnackbar(true);
  };
  const handleClick = async (dataPage) => {
    console.log(dataPage);
    if (dataPage) {
      setCuentaSelect(dataPage);
      await loadList(dataPage);
    }
  };

  const columns = useMemo(
    () => [
      { header: "cliente", accessorKey: "cliente" },
      { header: "cuenta", accessorKey: "cuenta" },
      { header: "id Instance", accessorKey: "instance_id" },
      { header: "Instancia", accessorKey: "instance_name" },
      { header: "ip_privada", accessorKey: "ip_privada" },
      { header: "ip_publica", accessorKey: "ip_publica" },
      { header: "producto", accessorKey: "producto" },
      {
        header: "estado",
        accessorKey: "estado",
        // Desactivar advertencias específicas de eslint
        /* eslint-disable react/prop-types */
        Cell: ({ row }) => {
          const estado = row.original.estado; // Usar `row.original.estado`
          return (
            <MDBadge
              badgeContent={estado === "running" ? "running" : "stopped"}
              color={estado === "running" ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          );
        },
        /* eslint-enable react/prop-types */
      },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    const estado = row?.original?.estado;
    const isRunning = estado === "running";
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
        <MDTypography variant="body2" color="textSecondary">
          Off
        </MDTypography>
        <Switch
          checked={isRunning}
          onChange={() => {
            setRowToAction(row);
            if (!isRunning) setOpenConfirmOn(true);
            else setOpenConfirmOff(true);
          }}
          color="default"
        />
        <MDTypography variant="body2" color="textSecondary">
          On
        </MDTypography>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox m={1}>
                  <Autocomplete
                    disablePortal
                    id="cuentas-OnOff"
                    options={cuentasResize.map((option) => option.title)}
                    renderInput={(params) => <TextField {...params} label="Cuentas-OnOff" />}
                    onInputChange={(event, newCuentaValue) => {
                      handleClick({ newCuentaValue });
                    }}
                  />
                </MDBox>
              </Grid>
              {blocking ? (
                <AppLoading titleCustom={"Ec2-off-on"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      height={250}
                      renderOpcRows={renderOpcRowsSid}
                    />
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Snackbar para mostrar el estado de la instancia */}
      <MDSnackbar
        color={snackbarColor}
        icon={snackbarColor === "success" ? "check" : "warning"}
        title="Estado de la Instancia"
        content={snackbarContent}
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        close={() => setOpenSnackbar(false)}
      />

      {/* Dialog para confirmar apagar */}
      <Dialog open={openConfirmOff} onClose={() => setOpenConfirmOff(false)}>
        <DialogTitle>Confirmar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Se procederá a apagar la instancia: ${rowToAction?.original?.instance_id}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmOff(false)}>No</Button>
          <Button onClick={handleOff} color="primary">
            Sí
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog para confirmar encender */}
      <Dialog open={openConfirmOn} onClose={() => setOpenConfirmOn(false)}>
        <DialogTitle>Confirmar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Se procederá a encender la instancia: ${rowToAction?.original?.instance_id}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmOn(false)}>No</Button>
          <Button onClick={handleOn} color="primary">
            Sí
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

const cuentasResize = [
  { title: "pdn" },
  { title: "pdn-m1" },
  { title: "pdn-m2" },
  { title: "pdn-m3" },
  { title: "pdn-m4" },
  { title: "pdn-m5" },
  { title: "pdn-m6" },
  { title: "zeus" },
  { title: "staging" },
  { title: "gcp-m7" },
];

export default Dashboard;
